import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import FixedSlideNav from '../../components/navbar/FixedSlideNav'
import AppStore from 'store/AppStore'
import HomeAction from '../../home/actions/HomeAction'
import StationAction from '../actions/StationAction'
import OperationAction from '../../quality/components/operation/actions/OperationAction'
import { links } from '../constants/LinksConstants'
import DtoStation from '../dto/DtoStation'
import DtoPiezometer from '../../piezometry/dto/DtoPiezometer'
import DtoHydrometricStation from '../../hydrometry/dto/DtoHydrometricStation'
import PiezometerStationAction from '../actions/PiezometerStationAction'
import HydrometerStationAction from '../actions/HydrometerStationAction'
import ProductionUnitAction from '../../productionUnit/actions/ProductionUnitAction'
import DistributionUnitAction from '../../distributionUnit/actions/DistributionUnitAction'
import { execByType, getStation } from '../../utils/StationUtils'
import DtoAssociatedStation from '../dto/DtoAssociatedStation'
import SieauAction from '../../components/sieau/SieauAction'
import { getMapStateToProps, getPropTypes } from '../../utils/StoreUtils'
import { NEW, STATION_NAME_ASSOCIATION } from '../constants/StationConstants'
import WatershedAction from '../../referencial/components/watershed/actions/WatershedAction'
import HydrometryAction from '../../hydrometry/actions/HydrometryAction'
import i18n from 'simple-react-i18n'
import DtoAccountHabilitation from '../../account/dto/DtoAccountHabilitation'
import PluviometerDto from '../../pluviometry/dto/PluviometerDto'
import PluviometryAction from '../../pluviometry/actions/PluviometryAction'
import DtoProductionUnit from '../../productionUnit/dto/DtoProductionUnit'
import DtoDistributionUnit from '../../distributionUnit/dto/DtoDistributionUnit'
import DtoInstallation from '../../installation/dto/installation/DtoInstallation'
import PiezometryAction from '../../piezometry/actions/PiezometryAction'
import DtoPiezometerLight from '../../piezometry/dto/DtoPiezometerLight'
import ActionComponent from '../../components/ActionComponent'
import MaterielAction from '../../materiel/actions/MaterielAction'
import CampaignAction from '../../campaign/actions/CampaignAction'
import EventsAction from '../../events/actions/EventsAction'
import CityAction from '../../referencial/components/city/actions/CityAction'
import QualityAction from '../../quality/actions/QualityAction'
import ExportAction from '../../export/actions/ExportAction'
import { INSTALLATION_TYPE } from '../../installation/constants/InstallationConstants'
import { Outlet } from 'react-router-dom'
import { componentHasHabilitations } from '../../utils/HabilitationUtil'
import {
    H_MAT_MODULE,
    H_STATION_HYDRO_DASHBOARD,
    H_STATION_HYDRO_DESCRIPTION,
    H_STATION_HYDRO_DOCUMENTS,
    H_STATION_HYDRO_EVENTS,
    H_STATION_HYDRO_FOLLOW_UP,
    H_STATION_HYDRO_MAT,
    H_STATION_HYDRO_VALIDATION,
    H_STATION_HYDRO_MODELS,
    // H_STATION_INSTALLATION_AEP_INDICATOR,
    H_STATION_INSTALLATION_CONFORMITY,
    H_STATION_INSTALLATION_DASHBOARD,
    H_STATION_INSTALLATION_DESCRIPTION,
    H_STATION_INSTALLATION_DOCUMENTS,
    H_STATION_INSTALLATION_EVENTS,
    H_STATION_INSTALLATION_FOLLOW_UP,
    H_STATION_INSTALLATION_MAT,
    H_STATION_INSTALLATION_STEP,
    H_STATION_INSTALLATION_SUIVIPC,
    H_STATION_PIEZO_DASHBOARD,
    H_STATION_PIEZO_DESCRIPTION,
    H_STATION_PIEZO_DOCUMENTS,
    H_STATION_PIEZO_EVENTS,
    H_STATION_PIEZO_FOLLOW_UP,
    H_STATION_PIEZO_MAT,
    H_STATION_PIEZO_VALIDATION,
    H_STATION_PIEZO_MODELS,
    H_STATION_PLUVIO_DASHBOARD,
    H_STATION_PLUVIO_DESCRIPTION,
    H_STATION_PLUVIO_DOCUMENTS,
    H_STATION_PLUVIO_EVENTS,
    H_STATION_PLUVIO_MAT, H_STATION_PLUVIO_VALIDATION,
    H_STATION_QUALITO_DASHBOARD,
    H_STATION_QUALITO_DESCRIPTION,
    H_STATION_QUALITO_DOCUMENTS,
    H_STATION_QUALITO_EVENTS,
    H_STATION_QUALITO_HYDROBIO_MONITORING,
    H_STATION_QUALITO_HYDROBIO_OPERATIONS,
    H_STATION_QUALITO_MAT,
    H_STATION_QUALITO_OPERATIONS,
    H_STATION_QUALITO_STATES,
    H_STATION_QUALITO_SUIVI_PC,
    H_UNITS_CONFORMITY,
    H_UNITS_COUNTERS,
    H_UNITS_DASHBOARD,
    H_UNITS_DESCRIPTION,
    H_UNITS_DOCUMENTS,
    H_UNITS_EVENTS,
    H_UNITS_GRAPHIC,
    H_UNITS_SUIVIPC,
} from '../../account/constants/AccessRulesConstants'
import BoundaryError from 'log/components/BoundaryError'
import AgriAction from 'agriAdministration/actions/AgriAction'
import { AGRI } from 'administration/components/user/constants/HabilitationConstants'
import { ProductionUnitActionConstant } from 'productionUnit/reducers/ProductionUnitReducer'
import { PluviometryActionConstant } from 'pluviometry/reducers/PluviometryReducer'
import { STATION_TYPE_CONSTANT } from 'station/constants/StationConstants'
import AdministrationAction from 'administration/actions/AdministrationAction'
import { DistributionUnitActionConstant } from 'distributionUnit/reducers/DistributionUnitReducer'
import DtoQualityIndicators from 'quality/dto/QualityIndicator/DtoQualityIndicators'
import InstallationAction from 'installation/actions/InstallationAction'
import ParameterAction from 'referencial/components/parameter/actions/ParameterAction'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import UnitAction from 'referencial/components/unit/actions/UnitAction'

const propsToFetch = {
    qualitometers: true,
    settings: false,
    hydrometricStation: true,
    hydrometricStations: true,
    cities: false,
    sandreCodes: true,
    productionUnit: false,
    productionUnits: true,
    distributionUnit: false,
    installation: false,
    stationTypes: false,
}

class StationApp extends ActionComponent {
    constructor(props) {
        super(props)
        this.state = {
            stationTypes: props.stationTypes,
            associatedSitesFetched: false,
            filesFetched: false,
            picturesFetched: false,
        }
    }

    onRemount = () => {
        this.setState({ stationTypes: [], associatedSitesFetched: false, filesFetched: false, picturesFetched: false }, this.onResetStationTypes)
    }

    onResetStationTypes = () => {
        this.resetData()
        this.fetchData()
    }

    componentDidMount() {
        this.fetchData()
        this.checkStationTypes(this.props)
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.type !== nextProps.type || this.props.params.id !== nextProps.params.id) {
            this.onRemount()
        }

        ['quality', 'piezometry', 'pluviometry', 'hydrometry', 'productionUnit', 'distributionUnit', 'installation'].map(type => {
            const station = getStation(this.props, type)
            const nextStation = getStation(nextProps, type)
            if (!station.id && nextStation.id) {
                this.onReceiveStation(nextProps, type)
            }
        })
    }

    onReceiveStation = (props, type) => {
        execByType(type, {
            quality: () => {
                if (props.qualitometer.id) {
                    AppStore.dispatch(HomeAction.setHelpLink('qualite', '5'))
                    AppStore.dispatch(SieauAction.fetch('stationEvents', type, props.qualitometer.id))
                    AppStore.dispatch(StationAction.fetchQualitomerWaterMass(props.qualitometer.id))
                    this.props.fetchQualitometerPoints(props.qualitometer.id)
                    if (!this.props.qualityIndicators.length) {
                        this.props.fetchQualityIndicators()
                    }
                }
            },
            piezometry: () => {
                if (props.piezometer.id) {
                    AppStore.dispatch(HomeAction.setHelpLink('piezometrie', ''))
                    AppStore.dispatch(SieauAction.fetch('stationEvents', type, props.piezometer.id))
                    this.props.fetchAllPiezometerActions(props.piezometer.id)
                }
            },
            pluviometry: () => {
                if (props.pluviometer.id) {
                    AppStore.dispatch(HomeAction.setHelpLink('pluviometrie', ''))
                    AppStore.dispatch(SieauAction.fetch('stationEvents', type, props.pluviometer.id))
                    this.props.fetchPluviometerCentralAssignment(props.pluviometer.id)
                    this.props.fetchPluviometerPowerSupplyAssignment(props.pluviometer.id)
                    this.props.fetchPluviometerSensorAssignment(props.pluviometer.id)
                    this.props.fetchPluviometerSimAssignment(props.pluviometer.id)
                    this.props.fetchPluviometerTelecomAssignment(props.pluviometer.id)
                    this.props.fetchPluviometerVariousMaterielAssignment(props.pluviometer.id)
                    this.props.fetchPluviometerEquipmentAssignment(props.pluviometer.id)
                    this.props.fetchPluviometerSubscriptionAssignment(props.pluviometer.id)
                }
            },
            hydrometry: () => {
                if (props.hydrometricStation.id) {
                    AppStore.dispatch(HomeAction.setHelpLink('hydrometrie', ''))
                    AppStore.dispatch(SieauAction.fetch('stationEvents', type, props.hydrometricStation.id))
                    this.props.fetchHydrometryCentralAssignment(props.hydrometricStation.id)
                    this.props.fetchHydrometryPowerSupplyAssignment(props.hydrometricStation.id)
                    this.props.fetchHydrometrySensorAssignment(props.hydrometricStation.id)
                    this.props.fetchHydrometrySimAssignment(props.hydrometricStation.id)
                    this.props.fetchHydrometryTelecomAssignment(props.hydrometricStation.id)
                    this.props.fetchHydrometryVariousMaterielAssignment(props.hydrometricStation.id)
                    this.props.fetchHydrometryEquipmentAssignment(props.hydrometricStation.id)
                    this.props.fetchHydrometrySubscriptionAssignment(props.hydrometricStation.id)
                }
            },
            productionUnit: () => {
                AppStore.dispatch(HomeAction.setHelpLink('', ''))
            },
            distributionUnit: () => {
                AppStore.dispatch(HomeAction.setHelpLink('', ''))
                AppStore.dispatch(SieauAction.fetch('stationEvents', type, props.distributionUnit.id))
                this.props.fetchDistributionUnitLink(props.distributionUnit.id)
            },
            installation: () => {
                AppStore.dispatch(HomeAction.setHelpLink('', ''))
                this.props.fetchInstallationCentralAssignment(props.installation.id)
                this.props.fetchInstallationPowerSupplyAssignment(props.installation.id)
                this.props.fetchInstallationSensorAssignment(props.installation.id)
                this.props.fetchInstallationSimAssignment(props.installation.id)
                this.props.fetchInstallationTelecomAssignment(props.installation.id)
                this.props.fetchInstallationVariousMaterielAssignment(props.installation.id)
                this.props.fetchInstallationEquipmentAssignment(props.installation.id)
                AppStore.dispatch(SieauAction.fetch('installationAssociations', props.installation.id))
            },
        })
        const station = getStation(props, type)
        const stationTypeName = STATION_NAME_ASSOCIATION[this.props.type]
        if (stationTypeName) {
            const found = this.props.stationTypes.find(t => t.name === stationTypeName)
            if (station && found) {
                this.props.fetchAssociatedSites(station.code, found.code).then(() => this.setState({ associatedSitesFetched: true }))
            }
        }
    }

    componentWillUnmount() {
        this.resetData()
    }

    fetchData = () => {
        const { params, type, accountHabilitations } = this.props
        AppStore.dispatch(HomeAction.setBackPath(`/${type}`))
        this.props.fetchParameters()
        this.props.fetchContributors()
        this.props.fetchUnits()
        this.props.fetchPiezometersLight()
        this.props.fetchPluviometers()
        this.props.fetchCities()
        this.props.fetchMaterielTypes()
        if (accountHabilitations.some((h) => h.habilitation === AGRI)) {
            this.props.fetchExploitationsLight()
        }

        this.fetchStation(type, params.id)
        AppStore.dispatch(SieauAction.fetch(propsToFetch))
        AppStore.dispatch(HomeAction.setHelpLink('qualite'))

        this.props.fetchApplicationSettings()
    }

    resetData = () => {
        AppStore.dispatch(SieauAction.update('selectedSearchValues', 'quality', { displayInListMode: false }))
        AppStore.dispatch(StationAction.resetStation())
        AppStore.dispatch(SieauAction.reset('suiviPC'))
        AppStore.dispatch(OperationAction.fetchReset())
        AppStore.dispatch(PiezometerStationAction.reset())
        AppStore.dispatch(HydrometerStationAction.reset())
        AppStore.dispatch(PluviometryActionConstant.resetPluviometerStation())
        AppStore.dispatch(ProductionUnitActionConstant.resetProductionUnit())
        AppStore.dispatch(SieauAction.reset(['installation', 'productionUnit', 'distributionUnit', 'stationEvents']))
        AppStore.dispatch(WatershedAction.resetWatershed())
        AppStore.dispatch(EventsAction.resetStationEvents())
        this.props.resetDistributionUnitLink()
    }

    checkStationTypes() {
        // this.setState({ stationTypes: [this.props.type] })
        // if (nextProps.qualitometers.length && nextProps.piezometers.length && nextProps.pluviometers.length && nextProps.hydrometricStations.length
        //     && this.state.stationTypes.length === 0 && station.code && nextProps.associatedSites.length) {

        // ['quality', 'pluviometry', 'piezometry', 'hydrometry'].map(type => {
        //     if (!stationTypes.find(elem => elem === type)) {
        //         execByType(type, {
        //             quality: () => {
        //                 const foundQualitometer = nextProps.qualitometers.find(elem => elem.code === station.code)
        //                 if (foundQualitometer && foundQualitometer.id) {
        //                     stationTypes.push(type)
        //                     this.fetchStation(type, foundQualitometer.id)
        //                 }
        //             },
        //             piezometry: () => {
        //                 const foundPiezometer = nextProps.piezometers.find(elem => elem.code === station.code)
        //                 if (foundPiezometer && foundPiezometer.id) {
        //                     stationTypes.push(type)
        //                     this.fetchStation(type, foundPiezometer.id)
        //                 }
        //             },
        //             pluviometry: () => {
        //                 const foundPluviometer = nextProps.pluviometers.find(elem => elem.code === station.code)
        //                 if (foundPluviometer && foundPluviometer.id) {
        //                     stationTypes.push(type)
        //                     this.fetchStation(type, foundPluviometer.id)
        //                 }
        //             },
        //             hydrometry: () => {
        //                 const foundHydrometricStation = nextProps.hydrometricStations.find(elem => elem.code === station.code)
        //                 if (foundHydrometricStation && foundHydrometricStation.id) {
        //                     stationTypes.push(type)
        //                     this.fetchStation(type, foundHydrometricStation.id)
        //                 }
        //             }
        //         })
        //     }
        // })

        // }
    }

    fetchDocumentsAssociated = (code, type) => {
        if (code?.replace(' ', '') !== '') {
            this.props.fetchPictures(code, type).then(() => this.setState({ picturesFetched: true }))
            this.props.fetchFiles(code, type).then(() => this.setState({ filesFetched: true }))
        }
    }

    fetchStation = (type, id) => {
        if (id && id !== NEW) {
            execByType(type, {
                quality: () => {
                    this.props.fetchQualitometer(id).then(() => {
                        this.fetchDocumentsAssociated(this.props.qualitometer.code, STATION_TYPE_CONSTANT.QUALITY)
                    })
                    this.props.fetchQualityCampaigns()
                    this.props.fetchQualityStationCampaigns()
                    this.props.fetchEnvironmentModelsByType(type)
                },
                piezometry: () => {
                    this.props.fetchPiezometer(id).then(() => {
                        this.fetchDocumentsAssociated(this.props.piezometer.code, STATION_TYPE_CONSTANT.PIEZOMETRY)
                    })
                    this.props.fetchPiezometryCampaigns()
                    this.props.fetchPiezometryStationCampaigns()
                    this.props.fetchEnvironmentModelsByType(type)
                },
                pluviometry: () => {
                    this.props.fetchPluviometer(id).then(() => {
                        this.fetchDocumentsAssociated(this.props.pluviometer.code, STATION_TYPE_CONSTANT.PLUVIOMETRY)
                    })
                    this.props.fetchPluviometryCampaigns()
                    this.props.fetchPluviometryStationCampaigns()
                    this.props.fetchEnvironmentModelsByType(type)
                },
                hydrometry: () => {
                    this.props.fetchHydrometricStation(id).then(() => {
                        this.fetchDocumentsAssociated(this.props.hydrometricStation.code, STATION_TYPE_CONSTANT.HYDROMETRY)
                    })
                    this.props.fetchHydrometryCampaigns()
                    this.props.fetchHydrometryStationCampaigns()
                    this.props.fetchEnvironmentModelsByType(type)
                },
                productionUnit: () => {
                    this.props.fetchProductionUnit(id).then(() => {
                        this.fetchDocumentsAssociated(this.props.productionUnit.code, STATION_TYPE_CONSTANT.PRODUCTION)
                        this.props.fetchProductionUnitLinks(id)
                    })
                    this.props.fetchProductionUnitEvents(id)
                },
                distributionUnit: () => {
                    this.props.fetchDistributionUnit(id).then(() => {
                        this.fetchDocumentsAssociated(this.props.distributionUnit.code, STATION_TYPE_CONSTANT.DISTRIBUTION)
                    })
                },
                installation: () => {
                    this.props.fetchInstallation(id).then(() => {
                        this.fetchDocumentsAssociated(this.props.installation.code, STATION_TYPE_CONSTANT.INSTALLATION)
                    })
                    this.props.fetch('installationEvents', id)
                    this.props.fetchInstallationCampaigns()
                    this.props.fetchInstallationStationCampaigns()
                },
            })
        }
    }

    getLink = (linkName) => {
        if (linkName !== 'materiel' || componentHasHabilitations(H_MAT_MODULE)) {
            return {
                ...links[linkName],
                href: `/station/${this.props.type}/${this.props.params.id}/${linkName}`,
                name: i18n[links[linkName].i18n],
                'data-cy': linkName,
            }
        }
        return null
    }

    getInstallationsLinks = () => {
        const isQualitoAssociated = this.props.associatedSites.some(site => site.stationLinkedType === 3)
        // const aepLinks = this.props.associatedSites.length > 0 && this.props.installation.installationType === INSTALLATION_TYPE.BOREHOLE ? [
        //     { habilitation: H_STATION_INSTALLATION_AEP_INDICATOR, link: 'installationAEPIndicators' },
        // ] : []
        const stepLinks = this.props.installation.installationType === INSTALLATION_TYPE.STEP ? [
            { habilitation: H_STATION_INSTALLATION_STEP, link: 'STEPTerritory' },
            { habilitation: H_STATION_INSTALLATION_STEP, link: 'STEPPollutionSearch' },
            { habilitation: H_STATION_INSTALLATION_STEP, link: 'export' },
        ] : []
        const qualityFeatures = isQualitoAssociated ? [
            { habilitation: H_STATION_INSTALLATION_SUIVIPC, link: 'pcMonitoring' },
            { habilitation: H_STATION_INSTALLATION_CONFORMITY, link: 'conformityOverview' },
        ] : []
        return [
            { habilitation: H_STATION_INSTALLATION_DASHBOARD, link: 'dashboard' },
            { habilitation: H_STATION_INSTALLATION_DESCRIPTION, link: 'description' },
            { habilitation: H_STATION_INSTALLATION_DASHBOARD, link: 'map' },
            { habilitation: H_STATION_INSTALLATION_EVENTS, link: 'event' },
            { habilitation: H_STATION_INSTALLATION_DOCUMENTS, link: 'picture' },
            { habilitation: H_STATION_INSTALLATION_FOLLOW_UP, link: 'installationFollowUp' },
            // ...aepLinks,
            ...qualityFeatures,
            { habilitation: H_STATION_INSTALLATION_MAT, link: 'materiel' },
            ...stepLinks,
        ]
    }

    render() {
        const navBarLinks = execByType(this.props.type, {
            quality: () => [
                { habilitation: H_STATION_QUALITO_DASHBOARD, link: 'dashboard' },
                { habilitation: H_STATION_QUALITO_DESCRIPTION, link: 'description' },
                { habilitation: H_STATION_QUALITO_DASHBOARD, link: 'map' },
                { habilitation: H_STATION_QUALITO_EVENTS, link: 'event' },
                { habilitation: H_STATION_QUALITO_DOCUMENTS, link: 'picture' },
                { habilitation: H_STATION_QUALITO_OPERATIONS, link: 'operation' },
                { habilitation: H_STATION_QUALITO_SUIVI_PC, link: 'suiviPC' },
                { habilitation: H_STATION_QUALITO_STATES, link: 'qualityStates' },
                { habilitation: H_STATION_QUALITO_HYDROBIO_OPERATIONS, link: 'hydrobioOperation' },
                { habilitation: H_STATION_QUALITO_HYDROBIO_MONITORING, link: 'hydrobioMonitoring' },
                { habilitation: H_STATION_QUALITO_MAT, link: 'materiel' },
            ],
            piezometry: () => [
                { habilitation: H_STATION_PIEZO_DASHBOARD, link: 'dashboard' },
                { habilitation: H_STATION_PIEZO_DESCRIPTION, link: 'description' },
                { habilitation: H_STATION_PIEZO_DASHBOARD, link: 'map' },
                { habilitation: H_STATION_PIEZO_EVENTS, link: 'event' },
                { habilitation: H_STATION_PIEZO_DOCUMENTS, link: 'picture' },
                { habilitation: H_STATION_PIEZO_FOLLOW_UP, link: 'piezometricFollowUp' },
                { habilitation: H_STATION_PIEZO_FOLLOW_UP, link: 'piezoSuiviTable' },
                { habilitation: H_STATION_PIEZO_VALIDATION, link: 'validation' },
                { habilitation: H_STATION_PIEZO_MAT, link: 'materiel' },
                { habilitation: H_STATION_PIEZO_MODELS, link: 'iaeauModels' },
            ],
            pluviometry: () => [
                { habilitation: H_STATION_PLUVIO_DASHBOARD, link: 'dashboard' },
                { habilitation: H_STATION_PLUVIO_DESCRIPTION, link: 'description' },
                { habilitation: H_STATION_PLUVIO_DASHBOARD, link: 'map' },
                { habilitation: H_STATION_PLUVIO_EVENTS, link: 'event' },
                { habilitation: H_STATION_PLUVIO_DOCUMENTS, link: 'picture' },
                { habilitation: H_STATION_PLUVIO_DASHBOARD, link: 'pluviometricFollowUp' },
                { habilitation: H_STATION_PLUVIO_DASHBOARD, link: 'pluviometricSuiviTable' },
                // { habilitation: H_STATION_PLUVIO_VALIDATION, link: 'validationData' },
                { habilitation: H_STATION_PLUVIO_VALIDATION, link: 'validationPluvio' },
                { habilitation: H_STATION_PLUVIO_MAT, link: 'materiel' },
            ],
            hydrometry: () => [
                { habilitation: H_STATION_HYDRO_DASHBOARD, link: 'dashboard' },
                { habilitation: H_STATION_HYDRO_DESCRIPTION, link: 'description' },
                { habilitation: H_STATION_HYDRO_DASHBOARD, link: 'map' },
                { habilitation: H_STATION_HYDRO_EVENTS, link: 'event' },
                { habilitation: H_STATION_HYDRO_DOCUMENTS, link: 'picture' },
                { habilitation: H_STATION_HYDRO_FOLLOW_UP, link: 'hydrometricFollowUp' },
                { habilitation: H_STATION_HYDRO_FOLLOW_UP, link: 'hydroSuiviTable' },
                { habilitation: H_STATION_HYDRO_FOLLOW_UP, link: 'observations' },
                { habilitation: H_STATION_HYDRO_VALIDATION, link: 'validationHydro' },
                { habilitation: H_STATION_HYDRO_MAT, link: 'materiel' },
                { habilitation: H_STATION_HYDRO_MODELS, link: 'iaeauModels' },
            ],
            installation: () => this.getInstallationsLinks(),
            units: () => {
                const isQualitoAssociated = this.props.associatedSites.some(site => site.stationLinkedType === 3)
                const qualityFeatures = isQualitoAssociated ? [
                    { habilitation: H_UNITS_GRAPHIC, link: 'graphic' },
                    { habilitation: H_UNITS_SUIVIPC, link: 'pcMonitoring' },
                    { habilitation: H_UNITS_CONFORMITY, link: 'conformityOverview' },
                ] : []
                const counters = this.props.type === 'distributionUnit' ? [
                    { habilitation: H_UNITS_COUNTERS, link: 'counters' },
                ] : []
                return [
                    { habilitation: H_UNITS_DASHBOARD, link: 'dashboard' },
                    { habilitation: H_UNITS_DESCRIPTION, link: 'description' },
                    { habilitation: H_UNITS_DASHBOARD, link: 'map' },
                    { habilitation: H_UNITS_EVENTS, link: 'event' },
                    { habilitation: H_UNITS_DOCUMENTS, link: 'picture' },
                    ...counters,
                    ...qualityFeatures,
                ]
            },
        })
            .filter(l => componentHasHabilitations(l.habilitation))
            .map(l => this.getLink(l.link))
            .filter(l => !!l)

        const main = (getStation(this.props, this.props.type) || {}).id ? (
            <main>
                <div className='row no-margin'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            <Outlet />
                        </BoundaryError>
                    </div>
                </div>
            </main>
        ) : null
        return (
            <div className='row no-margin'>
                <FixedSlideNav links={navBarLinks} />
                {main}
            </div>
        )
    }
}

StationApp.propTypes = getPropTypes(propsToFetch, {
    type: PropTypes.string.isRequired,
    qualitometer: PropTypes.instanceOf(DtoStation),
    piezometer: PropTypes.instanceOf(DtoPiezometer),
    pluviometers: PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
    pluviometer: PropTypes.instanceOf(PluviometerDto),
    piezometers: PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerLight)),
    hydrometricStation: PropTypes.instanceOf(DtoHydrometricStation),
    productionUnit: PropTypes.instanceOf(DtoProductionUnit),
    distributionUnit: PropTypes.instanceOf(DtoDistributionUnit),
    installation: PropTypes.instanceOf(DtoInstallation),
    children: PropTypes.element,
    params: PropTypes.shape({
        id: PropTypes.string.isRequired,
        code: PropTypes.string,
        materialType: PropTypes.string,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.object,
    }),
    getLink: PropTypes.func,
    popup: PropTypes.element,
    associatedSites: PropTypes.instanceOf(DtoAssociatedStation),
    accountHabilitations: PropTypes.arrayOf(PropTypes.instanceOf(DtoAccountHabilitation)),
    fetchAssociatedSites: PropTypes.func,
    fetchQualitometerPoints: PropTypes.func,
    fetchApplicationSettings: PropTypes.func,
    fetchDistributionUnitLink: PropTypes.func,
    resetDistributionUnitLink: PropTypes.func,
    fetchQualityIndicators: PropTypes.func,
    qualityIndicators: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualityIndicators)),
})

const mapStateToProps = store => getMapStateToProps(propsToFetch, {
    qualitometer: store.QualityReducer.qualitometer,
    piezometer: store.StationReducer.piezometer,
    piezometers: store.PiezometryReducer.piezometersLight,
    pluviometers: store.PluviometryReducer.pluviometers,
    pluviometer: store.PluviometryReducer.pluviometer,
    hydrometricStation: store.HydrometryReducer.hydrometricStation,
    productionUnit: store.ProductionUnitReducer.productionUnit,
    distributionUnit: store.DistributionUnitReducer.distributionUnit,
    installation: store.InstallationReducer.installation,
    popup: store.StationReducer.popup,
    associatedSites: store.StationReducer.associatedSites,
    accountHabilitations: store.AccountReducer.accountHabilitations,
    qualityIndicators: store.QualityReducer.qualityIndicators,
})

const mapDispatchToProps = {
    fetchParameters: ParameterAction.fetchParameters,
    fetchContributors: ContributorAction.fetchContributors,
    fetchUnits: UnitAction.fetchUnits,
    fetchPluviometers: PluviometryAction.fetchPluviometers,
    fetchPiezometersLight: PiezometryAction.fetchPiezometersLight,
    fetchCities: CityAction.fetchCities,
    fetchMaterielTypes: MaterielAction.fetchMaterielTypes,
    fetchInstallationCentralAssignment: StationAction.fetchInstallationCentralAssignment,
    fetchInstallationPowerSupplyAssignment: StationAction.fetchInstallationPowerSupplyAssignment,
    fetchInstallationSensorAssignment: StationAction.fetchInstallationSensorAssignment,
    fetchInstallationSimAssignment: StationAction.fetchInstallationSimAssignment,
    fetchInstallationTelecomAssignment: StationAction.fetchInstallationTelecomAssignment,
    fetchInstallationVariousMaterielAssignment: StationAction.fetchInstallationVariousMaterielAssignment,
    fetchInstallationEquipmentAssignment: StationAction.fetchInstallationEquipmentAssignment,
    fetchQualityCampaigns: CampaignAction.fetchQualityCampaigns,
    fetchQualityStationCampaigns: CampaignAction.fetchQualityCampaignStations,
    fetchPiezometryCampaigns: CampaignAction.fetchPiezometryCampaigns,
    fetchPiezometryStationCampaigns: CampaignAction.fetchPiezometryCampaignStations,
    fetchPluviometryCampaigns: CampaignAction.fetchPluviometryCampaigns,
    fetchPluviometryStationCampaigns: CampaignAction.fetchPluviometryCampaignStations,
    fetchHydrometryCampaigns: CampaignAction.fetchHydrometryCampaigns,
    fetchHydrometryStationCampaigns: CampaignAction.fetchHydrometryCampaignStations,
    fetchInstallationCampaigns: CampaignAction.fetchInstallationCampaigns,
    fetchInstallationStationCampaigns: CampaignAction.fetchInstallationCampaignStations,
    fetchAllPiezometerActions: EventsAction.fetchAllPiezometerActions,
    fetchAssociatedSites: StationAction.fetchAssociatedSites,
    fetchQualitometerPoints: QualityAction.fetchQualitometerPoints,
    fetchPictures: StationAction.fetchPictures,
    fetchFiles: StationAction.fetchFiles,
    fetchEnvironmentModelsByType: ExportAction.fetchEnvironmentModelsByType,
    fetchExploitationsLight: AgriAction.fetchExploitationsLight,
    fetchPluviometerCentralAssignment: StationAction.fetchPluviometerCentralAssignment,
    fetchPluviometerPowerSupplyAssignment: StationAction.fetchPluviometerPowerSupplyAssignment,
    fetchPluviometerSensorAssignment: StationAction.fetchPluviometerSensorAssignment,
    fetchPluviometerSimAssignment: StationAction.fetchPluviometerSimAssignment,
    fetchPluviometerTelecomAssignment: StationAction.fetchPluviometerTelecomAssignment,
    fetchPluviometerVariousMaterielAssignment: StationAction.fetchPluviometerVariousMaterielAssignment,
    fetchPluviometerEquipmentAssignment: StationAction.fetchPluviometerEquipmentAssignment,
    fetchPluviometerSubscriptionAssignment: StationAction.fetchPluviometerSubscriptionAssignment,
    fetchHydrometryCentralAssignment: StationAction.fetchHydrometryCentralAssignment,
    fetchHydrometryPowerSupplyAssignment: StationAction.fetchHydrometryPowerSupplyAssignment,
    fetchHydrometrySensorAssignment: StationAction.fetchHydrometrySensorAssignment,
    fetchHydrometrySimAssignment: StationAction.fetchHydrometrySimAssignment,
    fetchHydrometryTelecomAssignment: StationAction.fetchHydrometryTelecomAssignment,
    fetchHydrometryVariousMaterielAssignment: StationAction.fetchHydrometryVariousMaterielAssignment,
    fetchHydrometryEquipmentAssignment: StationAction.fetchHydrometryEquipmentAssignment,
    fetchHydrometrySubscriptionAssignment: StationAction.fetchHydrometrySubscriptionAssignment,
    fetchApplicationSettings: AdministrationAction.fetchApplicationSettings,
    fetchDistributionUnitLink: DistributionUnitAction.fetchDistributionUnitLink,
    resetDistributionUnitLink: DistributionUnitActionConstant.resetDistributionUnitLink,
    fetchQualityIndicators: QualityAction.fetchQualityIndicators,
    fetchPiezometer: StationAction.fetchPiezometer,
    fetchPluviometer: PluviometryAction.fetchPluviometer,
    fetchHydrometricStation: HydrometryAction.fetchHydrometricStation,
    fetchProductionUnit: ProductionUnitAction.fetchProductionUnit,
    fetchProductionUnitEvents: ProductionUnitAction.fetchProductionUnitEvents,
    fetchDistributionUnit: DistributionUnitAction.fetchDistributionUnit,
    fetch: SieauAction.fetch,
    fetchQualitometer: QualityAction.fetchQualitometer,
    fetchInstallation: InstallationAction.fetchInstallation,
    fetchProductionUnitLinks: ProductionUnitAction.fetchProductionUnitLinks,
}

export default connect(mapStateToProps, mapDispatchToProps)(StationApp)
